import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

const fetchSiteOperationalStatus = ({ filters, ...params }) => {
  const { url } = DepsService.rest.widgets.siteOperationalStatus;
  const queryParams = { ...params };
  const urlParams = { retailerId: filters.retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export default {
  fetchSiteOperationalStatus,
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/site-operational-status.api.js